import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  createRoutesFromElements,
  Route,
  ScrollRestoration,
} from "react-router-dom";
import { useEffect } from "react";
import { createGlobalStyle } from "styled-components";
import { CartProvider } from "./context/CartContext.js";
import { WishlistProvider } from "./context/WishlistContext.js";
import { initGA, logPageView } from "./analytics/Analytics.js";
import Footer from "./components/home/Footer/FooterNew";
import Header from "./components/home/Header/Header";
import SignIn from "./pages/Account/SignIn";
import SignUp from "./pages/Account/SignUp";
import Profile from "./pages/Account/Profile";
import Cart from "./pages/Cart/Cart";
import Contact from "./pages/Contact/Contact";
import Home from "./pages/Home/Home";
import Offer from "./pages/Offer/Offer";
import Payment from "./pages/payment/Payment";
import ProductDetails from "./pages/ProductDetails/ProductDetails";
import "font-awesome/css/font-awesome.min.css";
import ProdList from "./pages/productList/prodList.js";
import VerifyOtp from "./pages/Account/VerifyOtp.js";
import Success from "./pages/status/tStatus.js";
import FailStatus from "./pages/status/failStatus.js";
import Wishlist from "./pages/wishList/Wishlist.js";
import "@fontsource/sen"; // Importing the Sen font
import SearchEngine from "./pages/search/searchpage.js";
import IPDMeasurementGuide from "./components/home/Footer/IPDMeasurementGuide.js";
import ContactLensUsage from "./components/home/Footer/ContactLensUsage.js";
import EyewearMaterialGuide from "./components/home/Footer/EyewearMaterialGuide.js";
import PrivacyPolicy from "./components/home/Footer/PrivacyPolicy.js";
import ShippingPolicy from "./components/home/Footer/ShippingPolicy.js";
import RefundPolicy from "./components/home/Footer/RefundPolicy.js";
import Disclaimer from "./components/home/Footer/Disclaimer.js";
import LegalPolicy from "./components/home/Footer/LegalPolicy.js";
import TermsAndConditions from "./components/home/Footer/TermsAndConditions.js";
import ContactUs from "./components/home/Footer/ContactUs.js";
import { useLocation } from "react-router-dom";
import FounderPage from "./components/home/Footer/founder.js";
import ProtectedRoute from "./components/ProtectedRoute";
// Import the Layout component
import Layout from "./components/Layout/Layout";
// Import the ErrorPage component
import ErrorPage from "./pages/ErrorPage/ErrorPage";

// Then update your router definition to include a catch-all route
const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<Layout />}>
      <Route index element={<Home />} />
      <Route path="/offer" element={<Offer />} />
      <Route path="/product/:productId/:categoryId" element={<ProductDetails />} />
      <Route path="/cart" element={<Cart />} />
      <Route path="/prodList" element={<ProdList />} />
      <Route path="/searchEngine" element={<SearchEngine />} />
      <Route path="/paymentgateway" element={<Payment />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/signin" element={<SignIn />} />
      <Route path="/verifyOtp" element={<VerifyOtp />} />
      <Route path="/payment-success" element={<Success />} />
      <Route path="/payment-failure" element={<FailStatus />} />
      {/* Protected routes */}
      <Route path="/profile" element={
        <ProtectedRoute>
          <Profile />
        </ProtectedRoute>
      } />
      <Route path="/wishlist" element={<Wishlist />} /> {/* Removed ProtectedRoute wrapper */}
      <Route path="/cart" element={
        <ProtectedRoute>
          <Cart />
        </ProtectedRoute>
      } />
      
      <Route path="/contact" element={<Contact />} />
      <Route path="/ipd" element={<IPDMeasurementGuide />} />
      <Route path="/contactLensUsage" element={<ContactLensUsage />} />
      <Route path="/founder" element={<FounderPage />} />
      <Route path="/eyewearMaterialGuide" element={<EyewearMaterialGuide />} />
      <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
      <Route path="/shippingPolicy" element={<ShippingPolicy />} />
      <Route path="/refundPolicy" element={<RefundPolicy />} />
      <Route path="/disclaimer" element={<Disclaimer />} />
      <Route path="/legalPolicy" element={<LegalPolicy />} />
      <Route path="/terms-conditions" element={<TermsAndConditions />} />
      <Route path="/contactUs" element={<ContactUs />} />
      
      {/* Add the catch-all route for 404 errors */}
      <Route path="*" element={<ErrorPage />} />
    </Route>
  ),
  {
    future: {
      v7_normalizeFormMethod: true,
    },
  }
);

function App() {
  useEffect(() => {
    initGA(); // Initialize Google Analytics on app load
  }, []);

  return (
    <CartProvider>
      <WishlistProvider>
        <RouterProvider router={router} />
      </WishlistProvider>
    </CartProvider>
  );
}

export default App;
